import React from "react";
import Grid from "@mui/material/Grid2";
import { Box, Typography } from "@mui/material";
import Styles from "./Login.module.scss";
import { motion } from "framer-motion";
import { useState } from "react";
import Logo from "../../assets/images/Lamynaals_Tech_Logo-01 5.png";
import { Formik, Form, Field } from "formik";
import Email from "../../assets/images/email.svg";
import Ellipse_Top from "../../assets/images/Ellipse_Top.png";
import Ellipse_Bottom from "../../assets/images/Ellipse_bottom.png";
import Eye from "../../assets/images/eye.png";
import EyeClose from "../../assets/images/eyeClose.png";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";
import { loginApi } from "../../services/user.service";
import { useAuth } from "../../context/AuthProvider";
import { ToastError, ToastSuccess } from "../../utils/Toaster/Toaster";
import { landingPathFor } from "../../utils/roles";

const encrypt = (text) => btoa(text);
const decrypt = (text) => atob(text);

const carouselConfig = [
  {
    h1: "test,",
    h2: "Amplify Results",
    para: "Easily manage leave requests, tasks, employees, and clients in one place. Simplify your workflow and boost productivity.",
  },
  {
    h1: "Simplify Organized,",
    h2: "Stay Productive",
    para: "Manage projects and tasks efficiently, with real-time updates and progress tracking",
  },
  {
    h1: "Effortless Team,",
    h2: "Client Management",
    para: "Maintain client information and employee details in one place, making collaboration and communication smoother than ever",
  },
];

const Login = () => {
  const { commonLogin } = useAuth();
  const [selectedCarousel, setSelectedCarousel] = React.useState(0);
  const [showPass, setShowPass] = React.useState(false);
  const [rememberMe, setRememberMe] = React.useState(false);

  const navigate = useNavigate();
  const validationSchema = yup.object().shape({
    // email: yup.string().required("Please enter email"),
    email: yup
      .string()
      .email("Please enter a valid email address")
      .required("Please enter email"),
    password: yup.string().required("Please enter password"),
  });

  const onSubmit = async (values) => {
    try {
      const encodedPayload = {
        email: encrypt(values.email),
        password: encrypt(values.password),
      };

      const response = await commonLogin(encodedPayload);

      if (response?.data) {
        const {
          accessToken,
          id,
          name: encodedUserName,
          email: encodedEmail,
          isOverAllAdmin,
          isClient,
        } = response.data;

        const userName = decrypt(encodedUserName);
        const userEmail = decrypt(encodedEmail);
        const role = response.data.role;

        // LocalStorage is now handled in AuthProvider to prevent race conditions
        localStorage.setItem("role", role);
        localStorage.setItem("userName", userName);

        // Store credentials in localStorage if Remember Me is checked
        if (rememberMe) {
          localStorage.setItem("email", values.email);
          localStorage.setItem("password", values.password);
        } else {
          localStorage.removeItem("email");
          localStorage.removeItem("password");
        }

        navigate(landingPathFor(role, response.data.orgId));
        ToastSuccess(`Welcome ${userName}`);

      } else {
        ToastError(response?.message);
      }
    } catch (error) {
      ToastError(error?.data?.data?.message);
    }
  };

  React.useEffect(() => {
    const interval = setInterval(() => {
      setSelectedCarousel(
        (prevIndex) => (prevIndex + 1) % carouselConfig.length
      );
    }, 6000);

    return () => clearInterval(interval);
  }, [carouselConfig.length]);

  // Check if email and password are stored in localStorage and set them
  React.useEffect(() => {
    const storedEmail = localStorage.getItem("email");
    const storedPassword = localStorage.getItem("password");
    if (storedEmail && storedPassword) {
      setRememberMe(true);
    }
  }, []);

  return (
    <Grid container className={Styles.container}>
      <Grid
        size={{ xs: 12, sm: 12, md: 7, lg: 8 }}
        className={Styles.leftContainer}
      >
        <div className={Styles.ellipseTop}>
          <img src={Ellipse_Top} alt="/" />
        </div>
        <div className={Styles.ellipseBottom}>
          <img src={Ellipse_Bottom} alt="/" />
        </div>
        <Box className={Styles.carouselContent}>
          <Typography className={Styles.headerLabelOne}>
            {carouselConfig[selectedCarousel].h1}
          </Typography>
          <Typography className={Styles.headerLabelTwo}>
            {carouselConfig[selectedCarousel].h2}
          </Typography>
          <Typography className={Styles.headerLabelContent}>
            {carouselConfig[selectedCarousel].para}
          </Typography>
        </Box>
        <Box className={Styles.carouselPointer}>
          {carouselConfig.map((el, ind) => (
            <div
              key={ind}
              className={`${Styles.pointer} ${selectedCarousel === ind ? Styles.activePointer : ""
                }`}
            />
          ))}
        </Box>
      </Grid>
      <Grid
        size={{ xs: 12, sm: 12, md: 5, lg: 4 }}
        className={Styles.rightContainer}
      >
        <Box className={Styles.logo}>
          <img
            src={Logo}
            alt="Logo"
            style={{ height: "92px", width: "260px" }}
          />
        </Box>
        <Box className={Styles.loginBox}>
          <Typography className={Styles.welcomeLable}>
            Welcome Back !
          </Typography>
          <Typography className={Styles.welcomeMessage}>
            Login to stay organized, collaborate seamlessly.
          </Typography>
          <Formik
            initialValues={{
              email: localStorage.getItem("email") || "",
              password: localStorage.getItem("password") || "",
            }}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ touched, errors }) => (
              <Form>
                <Grid
                  container
                  rowSpacing={3}
                  mt={{ xs: 1, sm: 1, md: 1.5, lg: 3 }}
                >
                  <Grid size={{ xs: 12 }}>
                    <Typography className={Styles.inputTitle}>
                      Email ID
                    </Typography>
                    <div className={Styles.IconContainer}>
                      <Field
                        name="email"
                        className={Styles.inputBox}
                        placeholder="Enter your email ID"
                      />
                      <img src={Email} alt="" />
                    </div>
                    <div className="form-error" style={{ marginTop: 4 }}>
                      {touched.email && errors.email && errors.email}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12 }}>
                    <Typography className={Styles.inputTitle}>
                      Password
                    </Typography>
                    <div
                      className={`${Styles.IconContainer} ${Styles.eyeIconContainer}`}
                    >
                      <Field
                        name="password"
                        type={showPass ? "text" : "password"}
                        className={Styles.inputBox}
                        placeholder="Enter your password"
                      />
                      {showPass ? (
                        <img
                          src={Eye}
                          style={{ height: "26px", width: "26px" }}
                          alt=""
                          onClick={() => setShowPass(false)}
                        />
                      ) : (
                        <img
                          src={EyeClose}
                          style={{ height: "26px", width: "26px" }}
                          alt=""
                          onClick={() => setShowPass(true)}
                        />
                      )}
                    </div>
                    <div className="form-error" style={{ marginTop: 4 }}>
                      {touched.password && errors.password && errors.password}
                    </div>
                  </Grid>
                  <Grid size={{ xs: 12 }} className={Styles.checkBoxContainer}>
                    <input
                      type="checkbox"
                      className={Styles.customCheckbox}
                      checked={rememberMe}
                      onChange={() => setRememberMe(!rememberMe)}
                    />
                    <Typography className={Styles.rememberMeLabel}>
                      Remember me
                    </Typography>
                  </Grid>
                  <Grid
                    size={{ xs: 12 }}
                    className={Styles.loginButtonContainer}
                  >
                    <button type="submit">Login</button>
                  </Grid>
                </Grid>
              </Form>
            )}
          </Formik>
        </Box>
      </Grid>
    </Grid>
  );
};

export default Login;
